import {IValidationRule} from '@core/api/data-access';

import {signalStoreDefinition} from '../';

export const ValidationRulesStore = signalStoreDefinition({
	validations: null as IValidationRule[],
	loaded: false,
	loading: false,
	lastUpdated: 0,
});

export default ValidationRulesStore;
